import { render } from "./UserInfo.vue?vue&type=template&id=10c844d3&ts=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=10c844d3&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10c844d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10c844d3', __exports__)) {
    console.log('reload')
    api.reload('10c844d3', __exports__)
  }
  
  module.hot.accept("./UserInfo.vue?vue&type=template&id=10c844d3&ts=true", () => {
    console.log('re-render')
    api.rerender('10c844d3', render)
  })

}


export default __exports__